export default __webpack_public_path__ + "static/media/search.daf706e7.png";